import React, { Component } from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../actions";
import Dashboard from "./StudentAccount/Dashboard";
import UserProfile from "./StudentAccount/UserProfile";
import AdmissionForm from "./StudentAccount/AdmissionForm";
import "react-select/dist/react-select.css";
import "react-datepicker/dist/react-datepicker.css";

class Account extends Component {
  render() {
    if (this.props.auth.logOut) {
      return <Redirect exact to="/Login" />;
    }
    return (
      <div>
        {this.props.auth.userId && (
          <div>
            <Route
              exact
              path="/Account/StudentAccount/Dashboard"
              component={Dashboard}
            />
            <Route
              exact
              path="/Account/StudentAccount/UserProfile"
              component={UserProfile}
            />
            <Route
              path="/Account/StudentAccount/AdmissionForm/:TabIndex?/:FormId?"
              component={AdmissionForm}
            />
          </div>
        )}
      </div>
    );
  }
}
function mapStateToProps({ auth, userDetails }) {
  return { auth, userDetails };
}
export default connect(
  mapStateToProps,
  actions
)(Account);



// WEBPACK FOOTER //
// ./src/components/index.js